<template>
  <v-sheet
    v-if="event && !$vuetify.breakpoint.mobile"
    class="event-data-window"
    elevation="2"
    rounded
  >
    <div class="pa-2">
      <!-- Compact view -->
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <span class="text-subtitle-2">Lyönti #: {{ event.hit_number }}</span>
        </div>
        <div class="d-flex align-center">
          <span class="text-subtitle-2">Palot: {{ event.outs }}</span>
        </div>
        <v-btn
          icon
          x-small
          @click="expanded = !expanded"
        >
          <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>

      <!-- Expanded details -->
      <v-expand-transition>
        <div v-if="expanded">
          <v-divider class="my-2"></v-divider>
            <div class="text-body-2">
              <div class="d-flex justify-space-between mb-1">
                <span class="text-caption">Etenijä:</span>
                <span>{{ event.karkirunner_name || '-' }}</span>
              </div>
              <div v-if="event.vaara_alla" class="mt-3 d-flex justify-center">
                  <v-chip
                    small
                    color="primary"
                    text-color="white"
                  >
                    Väärä alla
                  </v-chip>
              </div>

            <!-- Run measurement data -->
            <div v-if="event.run?.run_id" class="mt-3">
              <div class="d-flex">
                <div class="text-center" style="width: 50%">
                  <div class="text-caption">Eteneminen</div>
                  <div class="text-h6 font-weight-medium">{{ formatTime(event.run.total_run_time) }}</div>
                </div>
                <div class="text-center" style="width: 50%">
                  <div class="text-caption">Lähtö</div>
                  <div class="text-h6 font-weight-medium">{{ formatTime(event.run.run_times?.lahto) }}</div>
                </div>
              </div>
            </div>

            <!-- Game phase -->
            <div v-if="event.game_phase" class="mt-2 border-top">
              <div class="text-center">
                <div class="font-weight-medium">{{ getGamePhaseText() }}</div>
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>
  </v-sheet>
</template>

<script>
import timeUtils from '@/utils/player/time.js'

export default {
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    expanded: true
  }),
  methods: {
    formatTime(seconds) {
      if (!seconds) return '-'
      return timeUtils.methods.secondsToPrettyTimer(seconds)
    },
    formatDuration(seconds) {
      if (!seconds) return '-'
      return seconds.toFixed(1)
    },
    getGamePhaseText() {
      if (!this.event?.game_phase) return ''

      const { jakso, inning, lopettava } = this.event.game_phase
      return `${jakso}J ${inning}${lopettava ? 'T' : 'A'}`
    }
  }
}
</script>

<style lang="scss" scoped>
.event-data-window {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 200px;
  background-color: rgba(255, 255, 255, 0.8) !important;
  z-index: 10;

  .v-sheet {
    background-color: transparent;
  }
}
</style>